import { useState } from "react";

import { ActionCodeContextProvider } from "~/contexts/action-code-context-provider";

import GuestTrackYourOrderStep1 from "./guest-track-your-order-step-1";
import GuestTrackYourOrderStep2 from "./guest-track-your-order-step-2";

enum TrackYourOrderSteps {
  Step1 = "Step1",
  Step2 = "Step2",
}

export default function GuestTrackYourOrder() {
  const [currentStep, setCurrentStep] = useState<TrackYourOrderSteps>(TrackYourOrderSteps.Step1);

  const goToNextStep = () => {
    setCurrentStep(TrackYourOrderSteps.Step2);
  };

  const goToPrevStep = () => {
    setCurrentStep(TrackYourOrderSteps.Step1);
  };

  const steps = {
    [TrackYourOrderSteps.Step1]: <GuestTrackYourOrderStep1 onNext={goToNextStep} />,
    [TrackYourOrderSteps.Step2]: <GuestTrackYourOrderStep2 onPrev={goToPrevStep} />,
  };

  return (
    <ActionCodeContextProvider>
      <div>{steps[currentStep]}</div>
    </ActionCodeContextProvider>
  );
}
